import React from "react";
import "./Button.scss";

export default function Button({
  text,
  className,
  href,
  newTab = false,
  download,
  rel,
  disabled = false,
}) {
  const downloadAttr =
    typeof download === "string" ? download : download ? "" : undefined;

  if (disabled) {
    return (
      <div className={className}>
        <span className="main-button main-button--disabled" aria-disabled="true">
          {text}
        </span>
      </div>
    );
  }

  if (newTab) {
    return (
      <div className={className}>
        <a
          className="main-button"
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          download={downloadAttr}
        >
          {text}
        </a>
      </div>
    );
  }

  return (
    <div className={className}>
      <a className="main-button" href={href} rel={rel} download={downloadAttr}>
        {text}
      </a>
    </div>
  );
}
